// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"dd448466","481":"db7d666e","985":"20e6cfce"}[chunkId] + ".chunk.js";
};